import { Component, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'zci-fake-step-one',
    templateUrl: './fake-step-one.component.html',
    standalone: true,
    styleUrls: ['./fake-step-one.component.css'],
    imports: [
        CommonModule
    ],
})
export class FakeStepOneComponent {

    @Input() nextStepClicked: EventEmitter<any>;
    @Input() nextStepReady: EventEmitter<any>;
    testClick() {
        this.nextStepReady.emit(true);
    }

}
